import { State } from '@meraki-internal/state';
import { ISmartStorageProvider, LocalStorageProvider } from './LocalStorageProvider';
import { DevSettingKey, DEV_SETTING_KEYS } from './DevSettingsMetadata';

export type IDevSettingsState = Record<DevSettingKey, boolean>;

export class DevSettingsStorage {
    settings: ISmartStorageProvider<{[key: string]: boolean}>;
    static inject = () => [LocalStorageProvider];
    constructor(private storage: LocalStorageProvider) {
        this.settings = this.storage.getJSONProvider('dev-settings', { userNeutral: true, envNeutral: true });
    }
}

// Interface merge — tells TypeScript that DevSettings instances have all boolean getters
export interface DevSettings extends IDevSettingsState {}

export class DevSettings extends State<IDevSettingsState> {
    static inject = () => [DevSettingsStorage];

    constructor(storage: DevSettingsStorage) {
        const settings = storage.settings.get() || {};
        const initialState = {} as IDevSettingsState;
        for (const key of DEV_SETTING_KEYS) {
            initialState[key] = settings[key] || false;
        }
        super(initialState);

        // Create getters dynamically so devSettings.someKey delegates to this.state.someKey
        for (const key of DEV_SETTING_KEYS) {
            Object.defineProperty(this, key, {
                get: () => this.state[key]
            });
        }
    }
}

export class DevSettingsWriter {
    static inject = () => [
        DevSettings,
        DevSettingsStorage
    ];
    constructor(
        private reader: DevSettings,
        private storage: DevSettingsStorage
    ){ };

    setSetting = async (key: string, value: any) => {
        this.reader.setState({ [key]: value } as Partial<IDevSettingsState>);
        this.persistLocalStorage();
    };

    private persistLocalStorage = () => {
        this.storage.settings.set({ ...this.reader.state });
    };
};
